package de.n4.careflex.login.exceptions

class AuthenticationFailedException(message: String? = null, cause: Throwable? = null): Exception(message, cause)